import React, { useReducer, useEffect, useContext, useRef} from "react";
import nivel1Context from "./nivel1Context";
import { getAllNivel1, addNivel1, updateNivel1, deleteNivel1, deleteNivel1AndChildren, updatePositioning } from "../../api/nivel1";
import areaReducer from "./nivel1Reducer";
import authContext from "../authentication/authContex";

//Types
import { 
    ACTUALIZAR_LIST_NIVEL1,
  } from "./nivel1Actions";
import { SocketContext } from "../socket/socket";
import Swal from "sweetalert2";

const Nivel1State = props =>{

    const initialState = {
        nivel1Lista: []
     };

    const [state, dispatch] = useReducer(areaReducer, initialState);

    const auContext = useContext(authContext);
    const {verificarTenant, usuario} = auContext;
    const server = useContext(SocketContext);
    const nivel1ListaRef = useRef(state.nivel1Lista);
    

    const actualizarNivel1List = async () => {
        try{
            const resp = await getAllNivel1();
            let nivel1 = resp.data.data;
            nivel1 = nivel1.map((lv1,i) => ({...lv1, position: lv1.position ?? i + 1})); //Si no tiene position seteado, utiliza el index del arreglo.
            nivel1ListaRef.current = nivel1;
            dispatch({
                type: ACTUALIZAR_LIST_NIVEL1,
                payload: nivel1
            });
            return nivel1;
        }catch(err){
            console.log(err)
        }

    };

    const agregarNivel1 = async (dato) => {

        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addNivel1
            const resp = await addNivel1(dato);
            const nivel1 = resp.data.data;
            return {saved:true, lv1Saved: nivel1};
        }catch(err){
            let msg = err.response?.data?.message ?? 'Error desconocido'
            let customMsg = msg.includes("duplicate key error") ? 'Código o Nombre se está repitiendo.' : msg;
            return {saved: false, msg: customMsg};  
        }
        
    };

    const modificarNivel1 = async (dato) => {
        try{
            const resp = await updateNivel1(dato);
            const nivel1 = resp.data.data;
            return nivel1;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarNivel1 = async (id) => {
        try{
            const resp = await deleteNivel1(id);
            const nivel1 = resp.data.data;
            return nivel1;
        }catch(err){
            console.log(err)
        }
    }

    const eliminarNivel1eHijos = async(id, deleteActivesToo = false, from = '') => {
        try {

            const resp = await deleteNivel1AndChildren(id, deleteActivesToo);
            const nivel1 = resp.data.data;
            const swalConfig = {title:'Eliminado!', html: nivel1, icon:'success'};
            if(from === 'TreeActivo') return swalConfig;
            Swal.fire(swalConfig);
            return nivel1;
        } catch (error) {
            console.log(error)
            const errorConfig = {title:'Ops!', text: error?.response?.data?.data ?? 'Error al eliminar', icon:'error'};
            if(from === 'TreeActivo') return errorConfig;
            if(error.response?.status == 401) Swal.fire(errorConfig);
        }
    }

    const updatePositionLv1 = async (updates) => {
        let lvs1Updated = nivel1ListaRef.current ?? [];
        lvs1Updated = lvs1Updated.map(a => {
            let lvFound = updates.find(upd => upd._id == a._id);
            return {
                ...a,
                position: lvFound ? lvFound.position : a.position
            }
        });
        nivel1ListaRef.current = lvs1Updated;
        await updatePositioning(updates);
        dispatch({
            type: ACTUALIZAR_LIST_NIVEL1,
            payload: lvs1Updated
        });
    }

    useEffect(() => {
        if(usuario != null) actualizarNivel1List();
    },[usuario])

    useEffect(()=>{
        if(server){
            server.on('nivel1sUpdated', ({tenantId}) => {
                console.log("Recibo el evento del Real Time Server nivel1sUpdated");
                let update = verificarTenant(tenantId);
                if(update){
                    actualizarNivel1List();
                }
            });

            server.on('nivel1Eliminated', ({tenantId}) => {
                let update = verificarTenant(tenantId);
                if(update){
                    actualizarNivel1List();
                }
            })

            return () => {
                server.off('nivel1sUpdated');
            }
        }
    },[server])

    return(
        <nivel1Context.Provider
            value={{
                nivel1Lista: state.nivel1Lista,
                actualizarNivel1List,
                agregarNivel1,
                modificarNivel1,
                eliminarNivel1,
                eliminarNivel1eHijos,
                updatePositionLv1,
            }}
        >
            {props.children}
        </nivel1Context.Provider>
    )

}

export default Nivel1State;